export default function (key) {
  return {
    create: {
      clear: `_CRUDL/${key}/create/CLEAR`,
      start: `_CRUDL/${key}/create/START`,
      success: `_CRUDL/${key}/create/SUCCESS`,
      failure: `_CRUDL/${key}/create/FAILURE`,
    },
    read: {
      clear: `_CRUDL/${key}/read/CLEAR`,
      start: `_CRUDL/${key}/read/START`,
      success: `_CRUDL/${key}/read/SUCCESS`,
      failure: `_CRUDL/${key}/read/FAILURE`,
    },
    update: {
      clear: `_CRUDL/${key}/update/CLEAR`,
      start: `_CRUDL/${key}/update/START`,
      success: `_CRUDL/${key}/update/SUCCESS`,
      failure: `_CRUDL/${key}/update/FAILURE`,
    },
    delete: {
      clear: `_CRUDL/${key}/delete/CLEAR`,
      start: `_CRUDL/${key}/delete/START`,
      success: `_CRUDL/${key}/delete/SUCCESS`,
      failure: `_CRUDL/${key}/delete/FAILURE`,
    },
    list: {
      clear: `_CRUDL/${key}/list/CLEAR`,
      start: `_CRUDL/${key}/list/START`,
      success: `_CRUDL/${key}/list/SUCCESS`,
      failure: `_CRUDL/${key}/list/FAILURE`,
      filter: `_CRUDL/${key}/list/FILTER`,
    },
  };
}
